import { translate } from "@/config/translator";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@fluentui/react-components";
import { MfaSetupContext } from "../useMfaSetup";
import { MfaMethodItem } from "@/components/mfaItem/mfaMethodItem";
import { useMfaSelectMethod } from "./mfaSelectMethod/useMfaSelectMethod";
import { Dispatch, SetStateAction } from "react";
import PspButton from "@/components/pspButton/PspButton";

type MfaSelectMethodProps = {
  onNext: () => void;
  onBack: () => void;
  setMfaSetupContext: Dispatch<SetStateAction<MfaSetupContext>>;
  mfaSetupContext: MfaSetupContext;
};

export function MfaSelectMethod({
  onBack,
  onNext,
  setMfaSetupContext,
  mfaSetupContext,
}: MfaSelectMethodProps) {
  const { lang, onBackWrapper } = useMfaSelectMethod({
    setMfaSetupContext,
    onBack,
  });

  return (
    <>
      <DialogTitle>{translate("setup2FaTitle", lang)}</DialogTitle>
      <DialogContent>
        <div className="flex flex-col gap-8 w-full mb-8">
          <p className="text-font-secondary">
            {translate("selectMfaMethod", lang)}
          </p>

          <div className="w-full flex flex-col gap-2">
            <MfaMethodItem
              selected={mfaSetupContext.chosenMethod === "authenticator"}
              onClick={() =>
                setMfaSetupContext((prev) => ({
                  ...prev,
                  chosenMethod: "authenticator",
                }))
              }
              type="totp"
              label={
                <div>
                  <div>{translate("authenticatorApp", lang)}</div>
                  <div className="text-font-secondary text-sm font-normal">
                    {translate("safest", lang)}
                  </div>
                </div>
              }
            />

            <MfaMethodItem
              disabled={mfaSetupContext.emailMethod?.isVerified}
              selected={mfaSetupContext.chosenMethod === "email"}
              type="email"
              onClick={() =>
                setMfaSetupContext((prev) => ({
                  ...prev,
                  chosenMethod: "email",
                }))
              }
              label={
                <div>
                  <div>{translate("email", lang)}</div>
                  {mfaSetupContext.emailMethod?.isVerified && (
                    <div className="text-font-secondary text-sm font-normal">
                      {translate("alreadyHaveEmailMethod", lang)}
                    </div>
                  )}
                </div>
              }
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <PspButton appearance="secondary" onClick={onBackWrapper}>
          {translate("cancel", lang)}
        </PspButton>
        <PspButton
          appearance="primary"
          disabled={!mfaSetupContext.chosenMethod}
          onClick={onNext}
        >
          {translate("continue", lang)}
        </PspButton>
      </DialogActions>
    </>
  );
}
